export enum DerVariant {
    Default = 'default',
    DefaultInverted = 'default-inverted',
    Reduced = 'reduced',
    ReducedInverted = 'reduced-inverted',
}

export enum Direction {
    Left = 'left',
    Right = 'right',
}
